import React, {useEffect, useRef, useState} from 'react';
import PopupSelectAdapter from "../PopupSelectAdapter";
import PropTypes from "prop-types";

import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'react-app-polyfill/ie11';
import PopupOptions from "../popup_select_component/PopupOptions";
import LinkForPopup from './link_implement/RecruitmentOrderingTypesPopupLink';
import {fetchPopupData} from "../popup_select_component/fetchPopupData";
import PopupSelect from "../PopupSelect";
import ReactDOM from "react-dom";

const RecruitmentOrderingTypesSearcher = props => {
  const [recruitmentOrderingIds, setRecruitmentOrderingIds] = useState(props.recruitment_ordering_ids);
  const [shouldSubmit, setShouldSubmit] = useState(false);

  useEffect(() => {
    if (shouldSubmit) {
      $('form').submit();
    }
  },[shouldSubmit]);

  const url = (() => {
    const path = '/popup/recruitment_ordering_types';
    const data = {
      selected_ids: recruitmentOrderingIds.split(","),
      is_limited_item: 0
    };
    return path + '?' + (new URLSearchParams(data)).toString();
  })();

  const onClosePopup = selectedRecruitmentOrderingTypes => {
    setRecruitmentOrderingIds(selectedRecruitmentOrderingTypes.map(sBT => sBT.id).join(','));
  };

  const onSubmit = () => {
    setShouldSubmit(true);
  };

  const onChangeRecruitmentOrderingIds = event => {
    setRecruitmentOrderingIds(event.target.value);
  };

  useEffect(() => {
    const handleCategoryChange = () => {
      const selectedRadio = document.querySelector('input[id="radio-03"]:checked');
      if (selectedRadio) {
        setRecruitmentOrderingIds(""); // カテゴリが変更されたらsetRecruitmentOrderingIdsを空にする
        document.querySelector('input[name="input_recruitment_ordering_name"]').value = "";
      }
    };

    document.addEventListener('change', handleCategoryChange);

    return () => document.removeEventListener('change', handleCategoryChange);
  }, []);

  return (
    <>
      <PopupSelectAdapter
        popupOptions={PopupOptions.recruitmentPrTypes}
        fetchedData={fetchPopupData(url)}
        needSelectedAllButton={false}
        rootNode={document.querySelector('#popup_member_recruitment_ordering')}
        onClosePopup={onClosePopup}
        onSubmit={onSubmit}
        selectedNames={props.input_recruitment_ordering_name}
        LinkForPopup={LinkForPopup}
        ButtonArea={ButtonArea}
      />
      <input type="hidden"
             name="q[custom_search_recruitment_ordering_id]"
             onChange={onChangeRecruitmentOrderingIds}
             value={recruitmentOrderingIds}
      />
    </>
  );
};

RecruitmentOrderingTypesSearcher.propTypes = {
  recruitment_ordering_ids: PropTypes.string,  // ie. "1,2,3"
  input_recruitment_ordering_name: PropTypes.string  // ie. "name1/name2/name3"
};

const ButtonArea = props => {
  return (
    <>
      <a className="back select-recruitment_ordering-btn" onClick={props.onClickCloseButton}>他の条件を選択</a>
      <a className="search search-recruitment_ordering-btn" onClick={props.onClickSubmitButton}>この条件で検索</a>
    </>
  );
};

export default RecruitmentOrderingTypesSearcher;
